import { useLocationContacts } from '@hakimo-ui/hakimo/data-access';
import { UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import ContactConnect from './contact-connect/ContactConnect';

interface Props {
  locationId: number;
  locationAlarmId?: string;
  alarmGroupId?: string;
  locationTenantId?: string;
  showTitle?: boolean;
  escalationId?: string;
  product?: UnifiedMonitoringProduct;
  timestamp?: string;
  timezone?: string;
}

export function LocationContacts(props: Props) {
  const {
    locationId,
    locationAlarmId,
    alarmGroupId,
    locationTenantId,
    showTitle = true,
    escalationId,
    product,
    timestamp,
    timezone,
  } = props;

  const queryResult = useLocationContacts(locationId);

  return (
    <QueryResult queryResult={queryResult}>
      {(contacts) => {
        const sortedContacts = contacts.sort((a, b) => b.priority - a.priority);
        return (
          <>
            {showTitle && (
              <h2 className="text-onlight-text-1 dark:text-dark-text mb-2 font-bold">
                Location Contacts
              </h2>
            )}
            <div className="mb-4 flex flex-col gap-2">
              {sortedContacts.map((contact) => (
                <ContactConnect
                  contact={contact}
                  selectableContacts={sortedContacts}
                  key={contact.id}
                  locationAlarmId={locationAlarmId}
                  alarmGroupId={alarmGroupId}
                  locationTenantId={locationTenantId}
                  locationId={locationId}
                  escalationId={escalationId}
                  product={product}
                  timestamp={timestamp}
                  timezone={timezone}
                />
              ))}
            </div>
            {sortedContacts.length === 0 && (
              <div className="p-2">
                <Alert>No contacts found</Alert>
              </div>
            )}
          </>
        );
      }}
    </QueryResult>
  );
}

export default LocationContacts;
